/*
  Snabbfilter och jämförelse på kollektionssidorna.

  Bygger på specraden som redan renderas i varje produktkort, alltså vikt,
  volym och mått. Ingen extra produktdata behövs och inga metafält.

  Filtren jobbar på de produkter som finns på den laddade sidan. Har kollektionen
  fler sidor filtreras bara den aktuella, vilket är rimligt eftersom kunden ändå
  ser resultatet direkt och kan bläddra vidare.

  Laddas med defer från sektionen, eftersom korten måste finnas i sidan först.
*/
(function () {
  'use strict';

  var MAX_COMPARE = 3;
  var selected = [];

  /* ---------- hjälpare ---------- */

  function num(str) {
    var m = String(str).match(/\d+(?:[.,]\d+)?/);
    return m ? parseFloat(m[0].replace(',', '.')) : null;
  }

  // Svensk decimalkomma. 2.3 ska visas som 2,3.
  function sv(n) {
    return n === null || n === undefined ? '' : String(n).replace('.', ',');
  }

  function parseCard(card) {
    var data = {
      el: card,
      handle: card.getAttribute('data-product-handle') || '',
      title: '',
      vendor: '',
      price: '',
      url: '',
      img: '',
      weight: null,
      volume: null,
      dims: null,
      dimsText: ''
    };

    var t = card.querySelector('.grid-product__title');
    if (t) data.title = t.textContent.trim();

    var v = card.querySelector('.grid-product__vendor');
    if (v) data.vendor = v.textContent.trim();

    var p = card.querySelector('.grid-product__price');
    if (p) data.price = p.textContent.replace(/\s+/g, ' ').trim();

    var a = card.querySelector('.grid-product__link');
    if (a) data.url = a.getAttribute('href');

    var i = card.querySelector('.grid-product__image-mask img');
    if (i) data.img = i.getAttribute('src') || i.getAttribute('data-src') || '';

    card.querySelectorAll('.tw-specs__item').forEach(function (s) {
      var txt = s.textContent.trim();
      if (/\bkg\b/i.test(txt)) {
        data.weight = num(txt);
      } else if (/\bl\b/i.test(txt) && !/x/i.test(txt)) {
        data.volume = num(txt);
      } else if (/x/i.test(txt)) {
        var nums = txt.match(/\d+(?:[.,]\d+)?/g);
        if (nums && nums.length >= 3) {
          data.dims = nums.slice(0, 3).map(function (n) { return parseFloat(n.replace(',', '.')); });
          data.dimsText = txt;
        }
      }
    });

    return data;
  }

  function fits(bag, limit) {
    if (!bag) return false;
    var b = bag.slice().sort(function (x, y) { return x - y; });
    var l = limit.slice().sort(function (x, y) { return x - y; });
    return b[0] <= l[0] && b[1] <= l[1] && b[2] <= l[2];
  }

  /* ---------- filterregler ---------- */

  var RULES = {
    ryanair_free: function (d) { return fits(d.dims, [40, 30, 20]); },
    cabin_ok: function (d) { return fits(d.dims, [55, 40, 23]); },
    under_2_5: function (d) { return d.weight !== null && d.weight <= 2.5; },
    under_3: function (d) { return d.weight !== null && d.weight <= 3; },
    over_90l: function (d) { return d.volume !== null && d.volume >= 90; }
  };

  /* ---------- init ---------- */

  var bar = document.querySelector('[data-tw-chips]');
  var cards = [].slice.call(document.querySelectorAll('.grid-product[data-product-handle]'));
  if (!cards.length) return;

  var items = cards.map(parseCard);

  /* ---------- snabbfilter ---------- */

  if (bar) {
    var chips = [].slice.call(bar.querySelectorAll('[data-tw-rule]'));
    var count = bar.querySelector('[data-tw-count]');
    var active = null;

    // Dölj chips som inte skulle ge några träffar. Bättre än ett tomt rutnät.
    chips.forEach(function (chip) {
      var rule = RULES[chip.getAttribute('data-tw-rule')];
      if (!rule) return;
      var hits = items.filter(rule).length;
      if (hits === 0) {
        chip.hidden = true;
      } else {
        var badge = chip.querySelector('[data-tw-chip-count]');
        if (badge) badge.textContent = hits;
      }
    });

    var apply = function (ruleName) {
      active = ruleName;
      var rule = ruleName ? RULES[ruleName] : null;
      var shown = 0;

      items.forEach(function (d) {
        var keep = !rule || rule(d);
        d.el.style.display = keep ? '' : 'none';
        if (keep) shown++;
      });

      chips.forEach(function (c) {
        var on = c.getAttribute('data-tw-rule') === ruleName;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (count) {
        count.textContent = ruleName ? shown + ' av ' + items.length + ' produkter' : '';
        count.hidden = !ruleName;
      }
    };

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var r = chip.getAttribute('data-tw-rule');
        apply(active === r ? null : r);
      });
    });
  }

  /* ---------- jämför ---------- */

  var comparable = items.filter(function (d) {
    return d.weight !== null || d.volume !== null || d.dims;
  });
  if (comparable.length < 2) return;

  comparable.forEach(function (d) {
    var wrap = d.el.querySelector('.grid-product__image-mask');
    if (!wrap) return;

    var lbl = document.createElement('label');
    lbl.className = 'tw-cmp__pick';
    lbl.innerHTML = '<input type="checkbox" aria-label="Jämför ' + d.title.replace(/"/g, '') + '"><span>Jämför</span>';
    wrap.appendChild(lbl);

    lbl.querySelector('input').addEventListener('change', function () {
      if (this.checked) {
        if (selected.length >= MAX_COMPARE) {
          this.checked = false;
          return;
        }
        selected.push(d);
      } else {
        selected = selected.filter(function (x) { return x !== d; });
      }
      renderBar();
    });
  });

  var tray = document.createElement('div');
  tray.className = 'tw-cmp__tray';
  tray.hidden = true;
  tray.innerHTML =
    '<div class="tw-cmp__tray-inner">' +
      '<span class="tw-cmp__tray-txt"></span>' +
      '<div class="tw-cmp__tray-btns">' +
        '<button type="button" class="tw-cmp__clear">Rensa</button>' +
        '<button type="button" class="tw-cmp__go">Jämför</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(tray);

  var modal = document.createElement('div');
  modal.className = 'tw-cmp__modal';
  modal.hidden = true;
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-label', 'Jämför väskor');
  modal.innerHTML =
    '<div class="tw-cmp__sheet">' +
      '<button type="button" class="tw-cmp__close" aria-label="Stäng">×</button>' +
      '<h2 class="tw-cmp__h">Jämför</h2>' +
      '<div class="tw-cmp__body"></div>' +
    '</div>';
  document.body.appendChild(modal);

  function renderBar() {
    if (!selected.length) {
      tray.hidden = true;
      return;
    }
    tray.hidden = false;
    tray.querySelector('.tw-cmp__tray-txt').textContent =
      selected.length === 1
        ? '1 väska vald, välj minst en till'
        : selected.length + ' väskor valda';
    tray.querySelector('.tw-cmp__go').disabled = selected.length < 2;
  }

  function row(label, vals, best) {
    var cells = vals.map(function (v, i) {
      var mark = best === i ? ' class="tw-cmp__best"' : '';
      return '<td' + mark + '>' + (v === null || v === '' ? '–' : v) + '</td>';
    }).join('');
    return '<tr><th scope="row">' + label + '</th>' + cells + '</tr>';
  }

  function lowest(nums) {
    var best = -1, val = Infinity;
    nums.forEach(function (n, i) {
      if (n !== null && n < val) { val = n; best = i; }
    });
    return nums.filter(function (n) { return n !== null; }).length > 1 ? best : -1;
  }

  function highest(nums) {
    var best = -1, val = -Infinity;
    nums.forEach(function (n, i) {
      if (n !== null && n > val) { val = n; best = i; }
    });
    return nums.filter(function (n) { return n !== null; }).length > 1 ? best : -1;
  }

  function openModal() {
    var heads = selected.map(function (d) {
      return '<th scope="col">' +
        (d.img ? '<img src="' + d.img + '" alt="">' : '') +
        '<a href="' + d.url + '">' + d.title + '</a>' +
        '</th>';
    }).join('');

    var weights = selected.map(function (d) { return d.weight; });
    var volumes = selected.map(function (d) { return d.volume; });

    var html =
      '<table class="tw-cmp__table">' +
        '<thead><tr><td></td>' + heads + '</tr></thead>' +
        '<tbody>' +
          row('Märke', selected.map(function (d) { return d.vendor; }), -1) +
          row('Pris', selected.map(function (d) { return d.price; }), -1) +
          row('Vikt', selected.map(function (d) { return d.weight === null ? null : sv(d.weight) + ' kg'; }), lowest(weights)) +
          row('Volym', selected.map(function (d) { return d.volume === null ? null : sv(d.volume) + ' L'; }), highest(volumes)) +
          row('Mått', selected.map(function (d) { return d.dimsText; }), -1) +
          row('Handbagage SAS', selected.map(function (d) { return fits(d.dims, [55, 40, 23]) ? 'Ja' : 'Nej'; }), -1) +
          row('Ryanair gratis', selected.map(function (d) { return fits(d.dims, [40, 30, 20]) ? 'Ja' : 'Nej'; }), -1) +
        '</tbody>' +
      '</table>' +
      '<p class="tw-cmp__note">Grön markering visar lättast respektive rymligast.</p>';

    modal.querySelector('.tw-cmp__body').innerHTML = html;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    modal.querySelector('.tw-cmp__close').focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  tray.querySelector('.tw-cmp__go').addEventListener('click', openModal);
  tray.querySelector('.tw-cmp__clear').addEventListener('click', function () {
    selected = [];
    document.querySelectorAll('.tw-cmp__pick input').forEach(function (i) { i.checked = false; });
    renderBar();
  });
  modal.querySelector('.tw-cmp__close').addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
})();
